import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import Page from './Page';

const QRCodes: FC = () => {
   
    return (
        <Page
            title="QR Code tools"
        >
            <ul>
                <li>
                    <Link to="/qrcode/website">QR Code Generator for websites</Link>
                </li>
                <li>
                    <Link to="/qrcode/wifi">QR Code Generator for WiFi</Link>
                </li>
            </ul>
        </Page>
    );
}

export default QRCodes;